<script>
import VBaseCard from "@/components/commonComponents/VBaseCard.vue";
import DictionariesSyncItem from "@/components/Dictionaries/DictionariesSyncItem.vue";
import UserAuth from "@/mixins/UserAuth";

export default {
    name: "DictionariesSync",
    components: {
        DictionariesSyncItem,
        VBaseCard,
    },
    mixins: [
        UserAuth,
    ],
    computed: {
        isDisabled() {
            return !this.user?.permissions?.byModule?.dictionary_sync?.canRead;
        },
    },
}
</script>

<template>
    <v-base-card
        v-if="!isDisabled"
        heading="Синхронизация справочников"
        hide-search
        hide-filter
    >
        <v-container fluid>
            <v-row>
                <v-col cols="12" sm="4">
                    <v-list>
                        <dictionaries-sync-item
                            :url="$apiUrl.getSyncEventsUrl()"
                            heading="Мероприятия"
                        ></dictionaries-sync-item>
                    </v-list>
                </v-col>
                <!--
                Q: Почему его нужно ставить вне <v-col/>?
                A: если внутри колонки, то надо колонку флексом делать и подстраивать паддинги колонки и отдельно v-list
                -->
                <v-divider vertical inset></v-divider>
                <v-col cols="12" sm="4">
                    <v-list>
                        <dictionaries-sync-item
                            :url="$apiUrl.getSyncSessionsUrl()"
                            heading="Сессии"
                        ></dictionaries-sync-item>
                    </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col cols="12" sm="4">
                    <v-list>
                        <dictionaries-sync-item
                            :url="$apiUrl.getSyncSpeakersUrl()"
                            heading="Спикеры"
                            v-slot="{data}"
                            incremental-sync
                        >
                            Цитат с несвязанными спикерами &mdash; {{ data.unbound.quotes }}
                        </dictionaries-sync-item>
                    </v-list>
                </v-col>

            </v-row>
        </v-container>
    </v-base-card>
</template>

<style scoped lang="scss">
    .v-divider--vertical.v-divider--inset {
        margin-top: 8px;
        margin-bottom: 8px;
    }
    .v-sheet.v-list {
        height: 100%;
    }
</style>
